import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WidgetSectionTitle from 'widgets/WidgetSectionTitle';
import paths from 'routes/paths';
import EmailProvider from './EmailProvider';
import ComposeEmail from './ComposeEmail';

const ComposeEmailPage = () => {
  const navigate = useNavigate();

  return (
    <EmailProvider>
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3">
          <WidgetSectionTitle
            icon="envelope"
            title="Compose Email"
            subtitle="Send an email to one or more recipients"
            className="mb-0"
          />
          <Button
            variant="primary"
            size="sm"
            onClick={() => navigate(paths.emailSent)}
          >
            <FontAwesomeIcon icon="arrow-left" className="me-2" />
            Back
          </Button>
        </div>
        <ComposeEmail
          asPage
          show
          onHide={() => navigate(paths.emailSent)}
        />
      </Container>
    </EmailProvider>
  );
};

export default ComposeEmailPage;
